import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { FetchStatus } from '@as-react/common-types';
import { useQuery } from '@tanstack/react-query';
import { AccountVouchers } from '../../components/account/account-vouchers/AccountVouchers';
const AccountVouchersContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { getVouchers } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: vouchers = [], isFetching, isError } = useQuery(getVouchers());
    const status = isFetching ? FetchStatus.PENDING : isError ? FetchStatus.REJECTED : FetchStatus.RESOLVED;
    return _jsx(AccountVouchers, { vouchers: vouchers, status: status, title: title });
};
export default AccountVouchersContainer;
